import {SubscriptionService} from "@/services/api/subscription/subscriptionService";

/**
 * Explicit Premium alias — same Verotel/premium contract as SubscriptionService.
 */
export class PremiumService extends SubscriptionService {}
